import { useRoutes } from "react-router-dom";
import { routerConfig } from "./routeConfig";

export const MainRoute = () => {
  const routers = useRoutes(routerConfig);
  return routers;
};
